import { useTranslation } from 'react-i18next';
import { Dialog } from '@/common/components/Dialog/Dialog';
import { Icon } from '@/common/components/Icons/Icon';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';

interface IConfirmCancelCardModalProps {
  onClose: () => void;
}

export const ConfirmCancelCardModal = ({
  onClose,
}: IConfirmCancelCardModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      icon={<Icon icon={'ban'} />}
      iconBadgeColor="accentSecondary20"
      title={t('dashboard.confirm_cancel_card_modal.title')}
      message={t('dashboard.confirm_cancel_card_modal.description')}
      primaryAction={{
        onPress: () => {
          AnalyticsService.openChat();
          onClose();
        },
        children: t('general.open_chat'),
      }}
      secondaryAction={{
        variant: 'secondary',
        onPress: onClose,
        children: t('general.navigation.close'),
      }}
      onClose={onClose}
    />
  );
};
